import { Badge, Card, Col, Container, Form, Row } from "react-bootstrap";

const CustomerData = ({ customerData }) => {
  
  return (
    <Container fluid className="mt-2">
      <Row className="justify-content-center">
        <Form.Group as={Col} xxl={6} xl={8} lg={10} md={12} sm={12}>
          {/* <Card className="border-0 shadow-sm">
            <Card.Body>
              <h6 className="mb-3">Customer Details</h6>
              <small className="text-muted d-block">Name</small>
              <div>{customerData.name}</div>

              <small className="text-muted d-block mt-2">Email</small>
              <div>{customerData.email}</div>

              <small className="text-muted d-block mt-2">Phone</small>
              <div>{customerData.phone}</div>

              <Badge bg="success" className="mt-3 text-capitalize">
                {customerData.status}
              </Badge>
            </Card.Body>
          </Card> */}
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-4">
              <h5 className="mb-3">Customer Details</h5>

              <div className="d-flex flex-column gap-2" style={{ fontSize: 14 }}>
                <div className="d-flex justify-content-between">
                  <span className="text-muted">Customer ID</span>
                  <span>{customerData.customerId}</span>
                </div>

                <div className="d-flex justify-content-between">
                  <span className="text-muted">Name</span>
                  <span>{customerData.name}</span>
                </div>

                <div className="d-flex justify-content-between">
                  <span className="text-muted">Email</span>
                  <span>{customerData.email}</span>
                </div>

                <div className="d-flex justify-content-between">
                  <span className="text-muted">Phone</span>
                  <span>{customerData.phone}</span>
                </div>

                <div className="d-flex justify-content-between">
                  <span className="text-muted">Status</span>
                  <Badge bg="success" className="text-capitalize">
                    {customerData.status}
                  </Badge>
                </div>

                <hr className="my-2" />

                <div className="d-flex justify-content-between">
                  <span className="text-muted">Created</span>
                  <span>
                    {new Date(customerData.createdAt).toLocaleString()}
                  </span>
                </div>

                <div className="d-flex justify-content-between">
                  <span className="text-muted">Updated</span>
                  <span>
                    {new Date(customerData.updatedAt).toLocaleString()}
                  </span>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Form.Group>
      </Row>
    </Container>
  );
};

export default CustomerData;
